import { Component, OnInit, ViewEncapsulation, input } from '@angular/core';

@Component({
    selector: 'ap-paragraph-skeleton',
    templateUrl: './paragraph-skeleton.component.html',
    styleUrls: ['./paragraph-skeleton.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class ApParagraphSkeletonComponent implements OnInit {
    /**
     * Number of rows to display in skeleton.
     * Defaults to 15
     */
    public readonly rows = input(15);

    public rowArray: Array<any>;

    public ngOnInit(): void {
        this.rowArray = new Array(this.rows());
    }
}
